import { render, staticRenderFns } from "./VideoBg.vue?vue&type=template&id=d3271a00&scoped=true&"
import script from "./VideoBg.vue?vue&type=script&lang=js&"
export * from "./VideoBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3271a00",
  null
  
)

export default component.exports